<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.qualifications
</script>

<div class="{klass}">
	<FormWithLabel
		label="資格"
		input={service.handleQualifications}
		values={$model.qualifications}
		inputType="checkboxes"
		options={$models}
	/>
</div>